export const DISPATCH_TYPE = {
  POOL: 'Compartilhado',
  DEDICATED: 'Dedicado',
};

export const DELIVERY_MODES = {
  ON_FOOT: 'A pé',
  BIKE: 'Bicicleta',
  MOTORCYCLE: 'Motocicleta',
  CAR: 'Carro',
};

export const STATUS = {
  ACTIVE: 'Ativo',
  APPROVED: 'Aprovado',
  BLOCKED: 'Bloqueado',
  DISAPPROVED: 'Reprovado',
  INACTIVE: 'Inativo',
  MANUAL_APPROVED: 'Aprovado manualmente',
  MANUAL_DISAPPROVED: 'Reprovado manualmente',
  OUT_OF_OPERATION: 'Fora de operação',
  PENDING: 'Pendente',
  READY_TO_DELIVER: 'Apto para realizar entrega',
  READY_FOR_TRAINING: 'Apto para treinamento',
  RESOLVE: 'Resolvido',
  RESOLVED: 'Resolvido',
  TRAINING: 'Em treinamento',
  WAITING_APPROVAL: 'Aguardando aprovação',
  WAITING: 'Em Espera',
};

export const STATUS_COLORS = {
  ACTIVE: 'green',
  APPROVED: 'blue',
  BLOCKED: 'red',
  DISAPPROVED: 'gray',
  INACTIVE: 'gray',
  MANUAL_APPROVED: 'blue',
  MANUAL_DISAPPROVED: 'gray',
  OUT_OF_OPERATION: 'pink',
  PENDING: 'orange',
  READY_TO_DELIVER: 'green',
  READY_FOR_TRAINING: 'pink',
  RESOLVE: 'green',
  RESOLVED: 'green',
  TRAINING: 'pink',
  WAITING_APPROVAL: 'purple',
  WAITING: 'blue',
};

export const OCCURRENCE_TYPES = {
  INSURANCE_TRIGGER: 'Acionamento de Seguro Acidentes Pessoais',
  LOCK_IN_THE_APP: 'Bloqueio de pessoa entregadora no aplicativo',
  DISREGARDING_THE_RULES_COVID_19: 'Desrespeito às normas da OMS quanto ao COVID-19',
  FINANCIAL_CREDIT: 'Financeiro (crédito)',
  FINANCIAL_DEBIT: 'Financeiro (débito)',
  INPRUDENCE_IN_TRANSIT: 'Imprudência no trânsito',
  POSTURE_OF_THE_DELIVERY_PERSON: 'Postura da pessoa entregadora',
  CHANGE_REGISTER_DATA: 'Solicitação de alteração de dados cadastrais',
};

export const DEMAND = {
  LOGISTIC: 'Logística',
  INSURANCE: 'Seguradora',
  NOT_FOWARDED: 'Não escalado',
};

export const DEMAND_STATUS = {
  PENDING: 'Pendente',
  WAITING: 'Em espera',
  RESOLVED: 'Resolvido',
};

export const DRIVER_RETURN = {
  YES: 'Sim',
  NO: 'Não',
};

export const FINANCIAL_OCC_CREDIT_TYPE = {
  ADVANCED_DELIVERY_FEE: 'Adiantamento da taxa de entrega',
  BONUS: 'Bônus - Programa de Indicação',
  PAID_RETURN_OF_MONEY: 'Devolução remunerada de dinheiro',
  PAID_RETURN_OF_MACHINE: 'Devolução remunerada da máquina de cartão',
  INCORRECT_SHIPPING_ADDRESS: 'Endereço de entrega incorreto',
  DELIVERY_CANCELED: 'Entrega cancelada - Usuário não encontrado',
  PROMO_DELIVERY_FEE_INCREMENT: 'Promoção - Incremento de taxa de entrega',
  PROMO_GUARANTEED_MINIMUM: 'Promoção - Mínimo garantido',
  RETURN_FOR_FAILURE_TO_PAY: 'Retorno por falha de pagamento',
  RETURN_FOR_LACK_OF_PRODUCT: 'Retorno por falta de produto',
  OTHER: 'Outro',
};

export const FINANCIAL_OCC_DEBIT_TYPE = {
  DISCOUNT_ON_MATERIALS_PROVIDED: 'Desconto de materiais fornecidos',
  DELIVERY_FEE_DISCOUNT: 'Desconto de taxa de entrega',
  DAMAGED_CARD_MACHINE: 'Máquina de cartão danificada',
  ORDER_DELIVERED_OUTSIDE: 'Pedido entregue fora das condições de consumo',
  ORDER_NOT_DELIVERED: 'Pedido não entregue',
  OTHER: 'Outro',
};

export const EDITABLE_STATUSES = [
  'APPROVED',
  'BLOCKED',
  'MANUAL_APPROVED',
  'READY_TO_DELIVER',
  'WAITING',
  'PENDING',
];

export const EDITABLE_STATUSES_GLOBAL = [
  'APPROVED',
  'BLOCKED',
  'MANUAL_APPROVED',
  'READY_TO_DELIVER',
  'WAITING',
];

export const POSSIBLE_STATUS_CHANGES = {
  APPROVED: 'READY_TO_DELIVER',
  MANUAL_APPROVED: 'READY_TO_DELIVER',
  BLOCKED: 'READY_TO_DELIVER',
  READY_TO_DELIVER: 'BLOCKED',
  PENDING: 'WAITING',
  WAITING: 'RESOLVED',
};

export const POSSIBLE_STATUS_CHANGES_OCCURRENCES = {
  APPROVED: 'READY_TO_DELIVER',
  MANUAL_APPROVED: 'READY_TO_DELIVER',
  BLOCKED: 'READY_TO_DELIVER',
  READY_TO_DELIVER: 'BLOCKED',
  PENDING: 'RESOLVED',
  WAITING: 'RESOLVED',
};

export const SEARCH_FIELD = {
  cpf: 'CPF',
  name: 'Nome',
  phone: 'Celular ',
};

export const OCCURRENCES_SEARCH_FIELD = {
  code: 'Código',
  occurrence_date: 'Data',
  reason: 'Motivo',
  financial_occ_type: 'Financeiro',
  value: 'Valor',
};

